export const setLoading = (key) => {
    return {
        type: 'user/setLoading',
        payload: key
    }
}
